import { render, staticRenderFns } from "./PlayStopToggle.vue?vue&type=template&id=0013645a&lang=pug&"
import script from "./PlayStopToggle.vue?vue&type=script&lang=ts&"
export * from "./PlayStopToggle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports